import { window } from '@mgmresorts/wcl-utils';

/**
 * On fullscreen,
 * show: mount -> container show (300ms) -> content show (300ms)
 * hide: content hide (300ms) -> container hide (300ms) -> dismount
 */

var fullscreenTransitionTimes = {
  containerShowDelay: 0,
  containerShowDuration: 300,
  contentShowDelay: 300,
  contentShowDuration: 300,
  containerHideDelay: 300,
  containerHideDuration: 300,
  contentHideDelay: 0,
  contentHideDuration: 300,
  // We add additional 400,
  // so all the animations have enough time to finish before the component gets dismounted
  dismountDelay: 300 * 2 + 400
};
var happoTransitionTimes = {
  containerShowDelay: 0,
  containerShowDuration: 0,
  contentShowDelay: 0,
  contentShowDuration: 0,
  containerHideDelay: 0,
  containerHideDuration: 0,
  contentHideDelay: 0,
  contentHideDuration: 0,
  dismountDelay: 0
};
var isHappo = window;
var ModalTransitionTimes = {
  fullscreen: isHappo ? happoTransitionTimes : fullscreenTransitionTimes,
  'fullscreen-wide': isHappo ? happoTransitionTimes : fullscreenTransitionTimes,
  'fullscreen-narrow': isHappo ? happoTransitionTimes : fullscreenTransitionTimes,

  /**
   * On centered:
   * show: mount -> container show (300ms) & content show (300ms)
   * hide: container show (300ms) & content show (300ms) -> dismount
   */
  centered: isHappo ? happoTransitionTimes : {
    containerShowDelay: 0,
    containerShowDuration: 300,
    // This is intentionally 1 instead of 0,
    // so that the content is rendered first by the browser,
    // before its' animation starts
    contentShowDelay: 1,
    contentShowDuration: 300,
    containerHideDelay: 0,
    containerHideDuration: 300,
    contentHideDelay: 0,
    contentHideDuration: 300,
    dismountDelay: 300
  },
  'centered-auto': isHappo ? happoTransitionTimes : {
    containerShowDelay: 0,
    containerShowDuration: 300,
    // This is intentionally 1 instead of 0,
    // so that the content is rendered first by the browser,
    // before its' animation starts
    contentShowDelay: 1,
    contentShowDuration: 300,
    containerHideDelay: 0,
    containerHideDuration: 300,
    contentHideDelay: 0,
    contentHideDuration: 300,
    dismountDelay: 300
  },

  /**
   * On bottom:
   * show: mount -> container show (300ms) & content show (300ms)
   * hide: container show (300ms) & content show (300ms) -> dismount
   */
  bottom: isHappo ? happoTransitionTimes : {
    containerShowDelay: 0,
    containerShowDuration: 300,
    // This is intentionally 1 instead of 0,
    // so that the content is rendered first by the browser,
    // before its' animation starts
    contentShowDelay: 1,
    contentShowDuration: 300,
    containerHideDelay: 0,
    containerHideDuration: 300,
    contentHideDelay: 0,
    contentHideDuration: 300,
    dismountDelay: 300
  }
};

export { ModalTransitionTimes, fullscreenTransitionTimes };
